export const getFilteredRoles = (roles, ignoringRoles) => roles.filter(
  (role) => !ignoringRoles.includes(role.description) && !ignoringRoles.includes(role.value)
);